import { render, staticRenderFns } from "./LaboratoryPromocodeEditModalNew.vue?vue&type=template&id=72ae982d"
import script from "./LaboratoryPromocodeEditModalNew.vue?vue&type=script&lang=js"
export * from "./LaboratoryPromocodeEditModalNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports